// src/pages/Trend/components/brand/BrandContentArea.js
import React from 'react';
import PropTypes from 'prop-types';
import BrandTable from '../../../Brand/components/BrandTable';
import BrandSearch from '../../../Brand/components/BrandSearch';
import { useLanguage } from '../../../../contexts/LanguageContext';
import './BrandContentArea.css';

const BrandContentArea = ({ brandState }) => {
  const { translate } = useLanguage();

  const {
    brands,
    loading,
    isSearchMode,
    params,
    pagination,
    handleSort,
    handlePageChange,
    handleSearch,
    handleReset
  } = brandState;

  /**
   * Render pagination
   */
  const renderPagination = () => {
    const currentPage = params.page;
    const totalPages = pagination.totalPages;

    if (totalPages <= 1) return null;

    const pageGroup = Math.floor((currentPage - 1) / 10);
    const groupStart = pageGroup * 10 + 1;
    const groupEnd = Math.min(groupStart + 9, totalPages);

    return (
      <div className="pagination">
        {groupStart > 1 && (
          <button
            className="pagination-button nav"
            onClick={() => handlePageChange(groupStart - 1)}
            aria-label="Previous page group"
          >
            {translate('brandPage.pagination.prev')}
          </button>
        )}

        {Array.from(
          { length: groupEnd - groupStart + 1 },
          (_, i) => groupStart + i
        ).map(page => (
          <button
            key={page}
            className={`pagination-button ${params.page === page ? 'active' : ''}`}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </button>
        ))}

        {groupEnd < totalPages && (
          <button
            className="pagination-button nav"
            onClick={() => handlePageChange(groupEnd + 1)}
            aria-label="Next page group"
          >
            {translate('brandPage.pagination.next')}
          </button>
        )}
      </div>
    );
  };

  return (
    <div className="brand-content-area">
      {/* Search */}
      <div className="brand-search-wrapper">
        <BrandSearch
          currentCategory={params.category}
          onSearch={handleSearch}
          onReset={handleReset}
        />
      </div>

      {/* Brand Table */}
      <BrandTable
        brands={brands}
        loading={loading}
        sortConfig={{ key: params.sortBy, direction: params.sortOrder }}
        onSort={handleSort}
        currentPage={params.page}
        perPage={params.perPage}
        isSearchMode={isSearchMode}
      />

      {/* Pagination */}
      {!loading && !isSearchMode && renderPagination()}
    </div>
  );
};

BrandContentArea.propTypes = {
  brandState: PropTypes.shape({
    brands: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
    isSearchMode: PropTypes.bool.isRequired,
    params: PropTypes.object.isRequired,
    pagination: PropTypes.object.isRequired,
    handleSort: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired
  }).isRequired
};

export default BrandContentArea;
